import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconBorderOutlineComponent } from "./med-icon-border-outline.component";

@NgModule({
  declarations: [
    MedIconBorderOutlineComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconBorderOutlineComponent,
  ],
})
export class MedIconBorderOutlineModule { }
